var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.035 8.41 6.743-6.745a.76.76 0 0 0 0-1.073.756.756 0 0 0-1.07 0L7.5 6.802 1.292.594a.757.757 0 1 0-1.07 1.072l6.743 6.746a.764.764 0 0 0 1.07 0Z",
    fill: "#FBFBFB"
  })));
};
export default SvgArrow;